import type { PriceListView, PriceResolveResult } from "@cx/contracts";
import { formatDateBR, formatPct, type PriceListKind } from "@cx/domain";

export const KIND_LABEL: Record<PriceListKind, string> = {
  rate: "Taxas",
  period: "Por período",
  custom: "Customizada",
};
export const BASE_LABEL = { price: "preço de venda", cost: "preço de custo" } as const;

const REASON: Record<string, string> = {
  no_list: "sem lista",
  inactive: "lista inativa",
  out_of_period: "fora da vigência",
  no_item: "produto fora da lista",
  below_min_qty: "abaixo da quantidade mínima",
};

/** Número do percentual sem o símbolo, para o campo com sufixo "%": "-12,5". */
export const pctNumber = (pct4: number) => formatPct(pct4).replace("%", "");

/** "+10%", "-12,5%", "0%". */
export const ratePct = (pct4: number) => (pct4 > 0 ? `+${formatPct(pct4)}` : formatPct(pct4));

export function validityText(from: string | null, to: string | null): string {
  if (from && to) return `${formatDateBR(from)} a ${formatDateBR(to)}`;
  if (from) return `A partir de ${formatDateBR(from)}`;
  if (to) return `Até ${formatDateBR(to)}`;
  return "Sem vigência";
}

/** "+10% sobre o preço de venda". Sem o % (lista de custo para quem não vê custo): "Percentual sobre o …". */
export const rateText = (pct4: number | null | undefined, base: PriceListView["base"]) =>
  `${pct4 === undefined ? "Percentual" : ratePct(pct4 ?? 0)} sobre o ${BASE_LABEL[base]}`;

export function ruleText(l: Pick<PriceListView, "kind" | "ratePct4" | "base" | "itemCount">): string {
  if (l.kind === "custom")
    return `Preço por produto (${l.itemCount} ${l.itemCount === 1 ? "produto" : "produtos"})`;
  return rateText(l.ratePct4, l.base);
}

export function priceSourceText(r: Pick<PriceResolveResult, "source" | "reason">): string {
  if (r.source === "list_rate") return "Percentual da lista";
  if (r.source === "item_price") return "Preço do produto na lista";
  if (r.source === "item_rate") return "Percentual do produto na lista";
  return r.reason ? `Preço do cadastro: ${REASON[r.reason]}` : "Preço do cadastro";
}
